import $ from 'jquery';

const scroll = () => {
  const $scroller = $('html,body');
  const $window = $(window);
  const $toTop = $(".m-scrollTopButton");

  $toTop.on('click', () => {
    $scroller.animate({ scrollTop: 0 });
  });

  // scrollでのtopボタン表示非表示
  $window.scroll(() => {
    const scrollTop = $window.scrollTop();

    if (window.innerHeight < scrollTop) {
      $toTop.removeClass("opacity-0 pointer-events-none");
    } else {
      $toTop.addClass("opacity-0 pointer-events-auto");
    }
  }).trigger('scroll');

  // リンク押下時のアニメーション
  $('a').on('click', (e) => {
    const href = $(e.currentTarget).attr('href');

    if (href && href.indexOf('#') === 0) {
      const $target = $(href);
      const headerHeight = $('header').innerHeight();

      $target.length && $scroller.animate({
        scrollTop: $target.offset().top - headerHeight - 10
      }, {
        duration: 1000,
      });
    }
  });
};

export default scroll;
